import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    IconButton,
} from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import AddIcon from '@mui/icons-material/Add';

import ExpandedTextField from '../display/ExpandedTextField';
import FullDataGrid from '../datagrid/FullDataGrid';

    // Datagrid column Definition for Metadata in DB
    const customMetaColumns = [
        {
            field: 'metadataName',
            headerName: 'Metadata Name',
            flex: 1,
        },
        {
            field: 'customString',
            headerName: 'Custom String',
            flex: 1,
            editable: true
        },
    ]

export default function CustomMetaPopover(props){

    const { setConfigRows, configRef, customRows, setCustomRows } = props

    const [metadataColName, setMetadataColName] = useState('')

    const customMetaRef = useGridApiRef()

    const addRow = () => {
        const id = customMetaRef.current.getSortedRowIds()
        customMetaRef.current.updateRows([{
            id: id.length > 0 ? id[id.length - 1] + 1 : 0,
            metadataName: metadataColName,
            customString: ''
        }])
        setMetadataColName('')
    }

    const saveChanges = () => {
        // Add the rows to the state
        setCustomRows((prev) => {
            return [...customMetaRef.current.getRowModels().values()]
        })
    }

    const handleCellClick = (params) => {
        if(params.colDef.editable === false){
            const orderedIDs = configRef.current.getSortedRowIds()
            setConfigRows((prev) => {
                return [...prev, {
                    id: orderedIDs.length > 0 ? orderedIDs[orderedIDs.length - 1] + 1 : 0,
                    metadataName: `Custom-${params.row.metadataName}`,
                    configName: params.row.metadataName
                }]
            })

        }
    }



    return (
        <Box
            width={'400px'}
            >
            <Box
                height={'480px'}
                overflow={'auto'}
            >
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    pb={'10px'}
                >
                    <ExpandedTextField
                        label="Metadata Name"
                        value={metadataColName}
                        onChange={(e) => setMetadataColName(e.target.value)}
                    />
                    <IconButton
                        sx={{ color: 'rgba(178, 235, 177, 1)' }}
                        onClick={addRow}
                        disabled={metadataColName ? false : true}
                    >
                        <AddIcon />
                    </IconButton>
                </Box>
            <Box height={'350px'}>
                <FullDataGrid
                    apiRef={customMetaRef}
                    rows={customRows}
                    columns={customMetaColumns}
                    onCellClick={handleCellClick}
                />
            </Box>
        </Box>
            <Box
                pt='10px'
                display={'flex'}
                justifyContent={'flex-end'}
            >
                <Button
                    sx={{ color: 'rgba(255, 255, 255, 1)' }}
                    onClick={saveChanges}
                >
                    Save
                </Button>
            </Box>
        </Box>
    )
}